
export const MODULE_NAME = 'errors'

export const ERRORS_ROUTES = {
  LAYOUT: MODULE_NAME,
  ERROR_404: `${MODULE_NAME}.404`,
  ERRORS: `${MODULE_NAME}.errors`,
} as const
